/**
 * How far a bump product reaches, said briefly enough for a list row.
 *
 * The count includes the page being edited, so a placement the seller is looking
 * at reads "On 1 page" rather than "Not used".
 */
export default function bumpUsageLabel(count) {
  if (!count) return 'Not used';
  if (count === 1) return 'On 1 page';

  return `On ${count} pages`;
}
